import React from 'react';
import { Typography } from "../ecosystem";
import VerifyEditButton from "./VerifyEditButton";

const VerifyDateTime = ({
    dayString,
    dateString,
    timeString,
    isMobile,
    isTablet,
    isDesktop,
    onEditClick
}) => {

    return (<div className="verify-date-time-container">
        <div className="verify-appointment-date">
            <div className="visit-day">
                <Typography type={isTablet || isDesktop ? "heading-01" : "meta-01"} color="$color-primary-a2">
                    {dayString}
                </Typography>
            </div>
            <div className="visit-month">
                <Typography type={isTablet || isDesktop ? "heading-06" : "heading-03"} color="$color-primary-a3">
                    {dateString}
                </Typography>
            </div>
        </div>
        <div className="verify-appointment-time">
            <div className="appoint-label">
                <Typography type={isTablet || isDesktop ? "heading-01" : "meta-01"} color="$color-primary-a2">
                    Appointment time
                </Typography>
            </div>
            <div className="appoint-time">
                <div className="visit-time">
                    <Typography type={isTablet || isDesktop ? "heading-06" : "heading-03"} color="$color-primary-a3">
                        {timeString}
                    </Typography>
                </div>
                <VerifyEditButton
                    onEditClick={onEditClick}
                    isTablet={isTablet}
                    isDesktop={isDesktop}
                />
            </div>
        </div>
    </div>);
}

export default VerifyDateTime;
